<template>
<v-container fluid>
  <v-layout wrap row>
    <v-flex lg3 md3 sm12 xs12>
     <v-container>
       <v-card flat>
         <v-container>
           <v-layout row wrap>
             <v-flex lg6 md6 sm12 xs12>
               <div class="stats-title pull-left">
                 <p>Persons Visiting</p>
               </div>
             </v-flex>
             <v-flex lg6 md6 sm12 xs12>
               <div class="stats-icon pull-right">
                 <i class="fa fa-users fa-2x"></i>
               </div>
             </v-flex>
             <v-flex lg12 md12 sm12 xs12>
               <h2 class="text-success">{{singleVisitor.visitor_count}}</h2>
             </v-flex>
           </v-layout>
         </v-container>
       </v-card>
     </v-container>
    </v-flex>
    <v-flex lg3 md3 sm12 xs12>
      <v-container>
        <v-card flat>
          <v-container>
            <v-layout row wrap>
              <v-flex lg6 md6 sm12 xs12>
                <div class="stats-title pull-left">
                  <p>Vehicle Details</p>
                </div>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <div class="stats-icon pull-right">
                  <i class="fa fa-car fa-2x"></i>
                </div>
              </v-flex>
              <v-flex lg12 md12 sm12 xs12>
                <h2 class="text-success">{{singleVisitor.visitor_vehicle_plate}}</h2>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-container>
    </v-flex>
    <v-flex lg3 md3 sm12 xs12>
      <v-container>
        <v-card flat>
          <v-container>
            <v-layout row wrap>
              <v-flex lg6 md6 sm12 xs12>
                <div class="stats-title pull-left">
                  <p>Visitor Contact</p>
                </div>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <div class="stats-icon pull-right">
                  <i class="fa fa-phone fa-2x"></i>
                </div>
              </v-flex>
              <v-flex lg12 md12 sm12 xs12>
                <h2 class="text-success">{{singleVisitor.visitor_phone_number}}</h2>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-container>
    </v-flex>
    <v-flex lg3 md3 sm12 xs12>
      <v-container>
        <v-card flat>
          <v-container>
            <v-layout row wrap>
              <v-flex lg6 md6 sm12 xs12>
                <div class="stats-title pull-left">
                  <p>Destination</p>
                </div>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <div class="stats-icon pull-right">
                  <i class="fa fa-phone fa-2x"></i>
                </div>
              </v-flex>
              <v-flex lg12 md12 sm12 xs12>
                <h2 class="text-success">{{singleVisitor.destination}}</h2>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-container>
    </v-flex>
  </v-layout>
  <v-layout row wrap>
    <v-flex lg4 md4 sm12 xs12>
     <v-container>
       <v-card color="primary" dark flat>
         <v-container>
           <div class="">
             <p>TIME IN</p>
             <p class="text-big font-light" style="font-size: 30px;">
               {{formated_date_time(singleVisitor.visitor_start_time)}}
             </p>
           </div>
         </v-container>
       </v-card>
       <br>
       <v-card color="orange" dark flat  v-if="singleVisitor.status === 'Authorised'">
         <v-container>
           <div class="">
             <p>AUTHORIZED</p>
             <p class="text-big font-light" style="font-size: 30px;">
               <small>Visitor(s) are still In.</small>
             </p>
           </div>
         </v-container>
       </v-card>
       <br>
       <v-card color="info" dark flat  v-if="singleVisitor.status === 'Closed'">
         <v-container>
           <div class="">
             <p>CLOSED</p>
             <small>Visitors are out.</small>
             <p>TIME OUT</p>
             <p class="text-big font-light" style="font-size: 30px;">
               {{formated_date_time(singleVisitor.visitor_end_time)}}
             </p>
           </div>
         </v-container>
       </v-card>
       <v-card color="info" dark flat>
         <v-container>
           <div class="">
             <p class="text-big font-light" style="font-size: 30px;">
               {{singleVisitor.visitor_staff_responsible_name}}
             </p>
             <small>Staff Responsible.</small>
           </div>
         </v-container>
       </v-card>
     </v-container>
    </v-flex>
    <v-flex lg8 md8 xs12 sm12>
      <v-card flat>
        <v-container>
          <div class="panel-body">
            <p>Visitor Type: <b>{{singleVisitor.visitor_type_name}}</b></p>
            <p>Name: <b>{{singleVisitor.visitor_name}}</b></p>
            <p>Organization: <b>{{singleVisitor.visitor_organisation}}</b></p>
            <p>Visitor Identification Type: <b>{{singleVisitor.visitor_identification_doc_type}}</b></p>
            <p>Visitor ID: <b>{{singleVisitor.visitor_identification_number}}</b></p>
            <div class="container-fluid">
              <hr>
              <h2 class="earth-color">PURPOSE</h2>
              <p>{{singleVisitor.visitor_purpose}}</p>
            </div>
          </div>
          <v-btn :depressed="true" color="info" block v-if="singleVisitor.status === 'Authorised'" @click="closeVisitation()" >Check-out</v-btn>

        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
export default {
  data () {
    return {}
  },
  created () {
    this.$store.dispatch('get_visitor', this.$route.params.visitor_id)
  },
  methods: {
    closeVisitation: function () {
      var data = {
        visitor: this.$route.params.visitor_id,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('close_visitation', data)
    }
  }
}
</script>

<style>

</style>
